export default __webpack_public_path__ + "static/media/profesional-a-cargo.99194741.svg";